import React, { MouseEvent, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import PreviewIcon from '@mui/icons-material/Preview';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import isEmpty from 'lodash/isEmpty';

import { useAppDispatch } from '../../../Hooks/useApp';
import { logout } from '../../../State/slices/authentication';
import './Navigation.css';

const pages = ['About', 'Blog', 'Listings', 'List your home', 'Still looking?', 'Login'];

// This is a whale of a file!
const Navigation = ({ onLegacyClick }: { onLegacyClick: () => void }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(sessionStorage.getItem('userId'));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    setIsLoggedIn(sessionStorage.getItem('userId'));
  }, [sessionStorage.getItem('userId')]);

  const [anchorElNav, setAnchorElNav] = useState<null | HTMLElement>(null);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const handleOpenNavMenu = (event: MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    sessionStorage.setItem('userId', '');
    sessionStorage.setItem('userEmail', '');
    sessionStorage.setItem('userFirstName', '');
    sessionStorage.setItem('userLastName', '');
    sessionStorage.setItem('isInBeta', 'false');

    dispatch(logout());

    navigate('/');
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const userName = sessionStorage.getItem('userFirstName')?.toLowerCase();

  return (
    <AppBar
      position='sticky'
      style={{
        backgroundColor: 'white',
        color: '#262626',
        boxShadow: 'none',
        borderBottom: 'solid lightgray 1px',
        fontSize: '1.1em',
      }}
    >
      <Container maxWidth='xl'>
        <Toolbar>
          <Typography
            variant='h6'
            noWrap
            component='a'
            onClick={() => navigate('/')}
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <img
              title='FLXlease logo'
              src='../../imgs/FLXLEASE_LOGO.png'
              className='navLogo'
              alt=''
              loading='eager'
            />
          </Typography>

          <Box
            sx={{
              flexGrow: 1,
              display: { xs: 'flex', md: 'none' },
              justifyContent: 'right',
              alignItems: 'center',
            }}
          >
            <Typography
              variant='h5'
              noWrap
              component='a'
              onClick={() => navigate('/')}
              sx={{
                mr: 2,
                display: { xs: 'flex', md: 'none' },
                flexGrow: 1,
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              <img
                title='FLXlease logo'
                src='../../imgs/FLXLEASE_LOGO.png'
                className='navLogo'
                alt=''
                loading='eager'
              />
            </Typography>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {/* -- Collapsed NavBar -- */}

              {pages.map((page) => {
                if (page === 'Login' && !isLoggedIn) {
                  return (
                    <Link key={page} to={`/${page}`}>
                      <MenuItem key={page} style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            margin: '1%',
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          <span className='LoginList'>{page}</span>
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                } else if (page === 'Login' && isLoggedIn) {
                  return (
                    <>
                      <MenuItem
                        key={page}
                        onClick={() => handleLogOut()}
                        style={{ width: '95vw' }}
                      >
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          <div>Log out</div>
                        </Typography>
                      </MenuItem>

                      <MenuItem
                        key={page}
                        onClick={() => onLegacyClick()}
                        style={{ width: '95vw' }}
                      >
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                          component='a'
                        >
                          <div>Beta App</div>
                        </Typography>
                      </MenuItem>

                      <Link key={page} to={'/profile'}>
                        <MenuItem style={{ width: '95vw' }}>
                          <Typography
                            textAlign='center'
                            style={{
                              margin: '1%',
                              fontSize: '17px',
                              width: '100%',
                            }}
                          >
                            <span className='LoginList'>Profile</span>
                          </Typography>
                        </MenuItem>
                      </Link>
                    </>
                  );
                } else if (page === 'List your home' && isLoggedIn) {
                  return (
                    <Link key={page} to={'/list-your-home'}>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            marginTop: '2%',
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                } else if (page === 'Still looking?' && isLoggedIn) {
                  return (
                    <Link key={page} to={'/still-looking'}>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                } else if (page === 'About') {
                  return (
                    <Link key={page} to={'/about'}>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                } else if (page === 'Blog') {
                  return (
                    <a key={page} href='https://blog.flxlease.com/blog'>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </a>
                  );
                } else if (page === 'Listings') {
                  return (
                    <Link key={page} to={'/listings'}>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            fontSize: '17px',
                            width: '100%',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                } else {
                  return (
                    <Link key={page} to={`/${page.toLowerCase()}`}>
                      <MenuItem style={{ width: '95vw' }}>
                        <Typography
                          textAlign='center'
                          style={{
                            marginTop: '2%',
                            fontSize: '17px',
                            width: '100%',
                            display: isLoggedIn ? 'block' : 'none',
                          }}
                        >
                          {page}
                        </Typography>
                      </MenuItem>
                    </Link>
                  );
                }
              })}
            </Menu>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              flexDirection: 'row',
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'right',
            }}
          >
            {/* -- Full NavBar -- */}

            {pages.map((page) => {
              if (page === 'Login' && !isLoggedIn) {
                return (
                  <Button
                    key={page}
                    onClick={() => navigate(`/${page.toLowerCase()}`)}
                    sx={{
                      my: 2,
                      color: '#262626',
                      display: 'block',
                      fontWeight: '500',
                      border: 'solid gray 1px',
                      borderRadius: '25px',
                      padding: '0 25px',
                      marginLeft: '1%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else if (page === 'Login' && isLoggedIn) {
                return (
                  <>
                    <Button
                      key={page}
                      sx={{
                        my: 2,
                        color: '#262626',
                        display: 'block',
                        fontWeight: '500',
                        border: 'solid gray 1px',
                        borderRadius: '100px',
                        padding: '0 25px',
                        marginLeft: '1%',
                        textTransform: 'none',
                        fontSize: '.8em',
                      }}
                      className='pages'
                      onClick={handleClick}
                    >
                      <div className='userCircle'>
                        {isLoggedIn
                          ? !isEmpty(sessionStorage.getItem('userFirstName'))
                            ? userName
                            : ''
                          : ''}
                      </div>
                    </Button>
                    <Popover
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      onClose={handleClose}
                      anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                      }}
                    >
                      <Typography
                        sx={{ p: 2, display: 'flex', fontSize: '1.1em' }}
                        className='popoverItem'
                        onClick={() => navigate(`/profile`)}
                      >
                        <PersonIcon /> &nbsp; Profile
                      </Typography>
                      <Typography
                        onClick={onLegacyClick}
                        className='popoverItem'
                        sx={{ p: 2, display: 'flex', fontSize: '1.1em' }}
                      >
                        <PreviewIcon />
                        &nbsp; Beta App
                      </Typography>
                      <Typography
                        onClick={handleLogOut}
                        className='popoverItem'
                        sx={{ p: 2, display: 'flex', fontSize: '1.1em' }}
                      >
                        <LogoutIcon /> &nbsp; Log out
                      </Typography>
                    </Popover>
                  </>
                );
              } else if (page === 'List your home' && isLoggedIn) {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => navigate('/list-your-home')}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: 'block',
                      marginLeft: '.6%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else if (page === 'Still looking?' && isLoggedIn) {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => navigate('/still-looking')}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: 'block',
                      marginLeft: '.6%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else if (page === 'About') {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => navigate('/about')}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: 'block',
                      marginLeft: '.6%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else if (page === 'Blog') {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => (window.location.href = 'https://blog.flxlease.com/blog')}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: 'block',
                      marginLeft: '.6%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else if (page === 'Listings') {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => navigate('/listings')}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: 'block',
                      marginLeft: '.6%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              } else {
                return (
                  <Button
                    key={page}
                    component='a'
                    onClick={() => navigate(`/${page.toLowerCase()}`)}
                    sx={{
                      my: 2,
                      color: '#262626',
                      fontWeight: '500',
                      display: isLoggedIn ? 'block' : 'none',
                      marginLeft: '1%',
                      textTransform: 'none',
                      fontSize: '.8em',
                    }}
                    className='pages'
                  >
                    {page}
                  </Button>
                );
              }
            })}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navigation;
